import React from "react";
import BikeImg from '../img/bic_big.png'
function Bike() {
  return (
    <img style={{width:"34px",height:"40px",marginBottom:"10px"}} src={BikeImg} alt='bike'></img>
  );
}

export default Bike;
